import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-onboarding-demo',
  templateUrl: './onboarding-demo.component.html',
  styleUrls: ['./onboarding-demo.component.scss']
})
export class OnboardingDemoComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
